import type { CreditGetResult } from 'app/src/services/welfareportal/shopping-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const creditSchema: z.ZodType<CreditGetResult & { membershipId: string }> = z.object({
  pdrAssigned: z.number(),
  fringeAssigned: z.number(),
  info: z.array(z.string()).optional(),
  creditByServiceCategory: z.record(
    z.string(),
    z.object({
      total: z.number().optional(),
      available: z.number().optional(),
    }),
  ),
  /** Used to mock credit for different memberships */
  membershipId: z.string(),
})
